import { createBrowserRouter } from "react-router-dom";
import Login from "../pages/auth/login";
import ForgotPin from "../pages/auth/forgot-pin";
import VerifyDevice from "../pages/auth/verify-device";
import Register from "../pages/auth/register";
import ResetPin from "../pages/auth/reset-pin";
import SetupPin from "../pages/auth/setup-pin";

import DashboardPage from "../pages/dashboard/page";
import ClientsPage from "../pages/comptes/clients";
import AgentsPage from "../pages/comptes/agents";
import AgentMonitor from "../pages/comptes/agent-monitor";
import UnvalidatedPage from "../pages/comptes/unvalidated";
import CardsPage from "../pages/comptes/cards";
import TransactionsPage from "../pages/transactions/transactions";
import PaymentsPage from "../pages/transactions/payments";
import NewTransactionPage from "../pages/transactions/new-transaction";
import WithdrawalRequestsPage from "../pages/transactions/withdrawal-requests";
import ConfigurationPage from "../pages/configuration/index";
import MobileConfigPage from "../pages/configuration/MobileConfig";
import UsersPage from "../pages/users/index";
import SurveillancePage from "../pages/surveillance/index";
import UserProfilePage from "../pages/settings/UserProfilePage";
import Profile from "../pages/profile/Profile";
import Home from "../pages/profile/Home";
import Wallet from "../pages/profile/Wallet";
import History from "../pages/profile/History";
import Services from "../pages/Services";
import BousanmSolide from "../pages/services/BousanmSolide";
import AcheterCredit from "../pages/services/AcheterCredit";
import StripePayment from "../pages/services/payment/StripePayment";
import ZellePayment from "../pages/services/payment/ZellePayment";
import PayPalPayment from "../pages/services/payment/PayPalPayment";
import Layout from "../components/profileUser/Layout";
import SharedAdminLayout from "../pages/includes/SharedAdminLayout";
import Construction from "../pages/includes/Construction";
import QrCodePage from "../pages/profile/QrCodePage";
import FeesPage from "../pages/administration/Fees";
import TransactionReviewsPage from "../pages/administration/TransactionReviews";
import RapportManagementPage from "../pages/administration/RapportManagement";
import { ProtectedRoute, PublicRoute, ADMIN_ROLES, FULL_ADMIN_ROLES, STAFF_ROLES } from "../components/ProtectedRoute";

// Card Module Admin
import ApplicationsPage from "../pages/cards/ApplicationsPage";
import CardsManagePage from "../pages/cards/CardsManagePage";
import RechargesPage from "../pages/cards/RechargesPage";
import LogsPage from "../pages/cards/LogsPage";
import VisaDashboardPage from "../pages/cards/VisaDashboardPage";
import VisaTransactionsPage from "../pages/cards/VisaTransactionsPage";
import CardConfigPage from "../pages/cards/CardConfigPage";

// Bousanm Solidaire Imports
import { BousanmSolideProvider } from "../pages/services/bousanm-solide/context/BousanmSolideContext";
import DashboardBS from "../pages/services/bousanm-solide/pages/DashboardBS";
import ClientsBS from "../pages/services/bousanm-solide/pages/ClientsBS";
import AgentsBS from "../pages/services/bousanm-solide/pages/AgentsBS";
import TransactionsBS from "../pages/services/bousanm-solide/pages/TransactionsBS";
import PlansBS from "../pages/services/bousanm-solide/pages/PlansBS";
import RapportsBS from "../pages/services/bousanm-solide/pages/RapportsBS";
import AgentsPortfolio from "../pages/services/bousanm-solide/pages/AgentsPortfolio";
import AgentDetail from "../pages/services/bousanm-solide/pages/AgentDetail";
import AssignationsManagement from "../pages/services/bousanm-solide/pages/AssignationsManagement";


import KolaboConnect from "../pages/services/KolaboConnect";
import KolaboTech from "../pages/services/KolaboTech";
import KolaboExpress from "../pages/services/KolaboExpress";
import HTLA from "../pages/services/HTLA";
import Imolink from "../pages/services/Imolink";
import Famamobile from "../pages/services/Famamobile";
import Biofrit from "../pages/services/Biofrit";

import { SessionProvider } from "../providers/SessionProvider";

export const router = createBrowserRouter([
    // ==========================================
    // PUBLIC ROUTES (No auth required)
    // ==========================================
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "/login",
        element: <Login />,
    },
    {
        path: "/auth/login",
        element: <Login />,
    },
    {
        path: "/forgot-pin",
        element: <PublicRoute><ForgotPin /></PublicRoute>,
    },
    {
        path: "/auth/forgot-pin",
        element: <PublicRoute><ForgotPin /></PublicRoute>,
    },
    {
        path: "/verify-device",
        element: <VerifyDevice />,
    },
    {
        path: "/auth/verify-device",
        element: <VerifyDevice />,
    },
    {
        path: "/register",
        element: <PublicRoute><Register /></PublicRoute>,
    },
    {
        path: "/auth/register",
        element: <PublicRoute><Register /></PublicRoute>,
    },
    {
        path: "/setup-pin",
        element: <SetupPin />,
    },
    {
        path: "/auth/setup-pin",
        element: <SetupPin />,
    },
    {
        path: "/reset-pin",
        element: <ResetPin />,
    },
    {
        path: "/auth/reset-pin",
        element: <ResetPin />,
    },


    // ==========================================
    // ADMIN ROUTES (Require admin roles)
    // ==========================================
    {
        path: "/dashboard",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><DashboardPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/clients",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><ClientsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/agents",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><AgentsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/agent-monitor",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><AgentMonitor /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/unvalidated",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><UnvalidatedPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/cards",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><CardsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/transactions",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><TransactionsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/payments",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><PaymentsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/transactions/new",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><NewTransactionPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/transactions/retrait-requests",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><WithdrawalRequestsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/administration/users",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><UsersPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/administration/fees",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><FeesPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/administration/reviews",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><TransactionReviewsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/administration/rapports",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><RapportManagementPage /></SessionProvider></ProtectedRoute>,
    },

    // ==========================================
    // CARD MODULE (VISA × HyperPay)
    // ==========================================
    {
        path: "/visa/dashboard",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><VisaDashboardPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/applications",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><ApplicationsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/cards",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><CardsManagePage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/recharges",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><RechargesPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/transactions",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><VisaTransactionsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/logs",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><LogsPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/visa/config",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><CardConfigPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/configuration",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><ConfigurationPage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/configuration/mobile",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><SharedAdminLayout><MobileConfigPage /></SharedAdminLayout></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/settings/profile",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><UserProfilePage /></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/surveillance",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><SurveillancePage /></SessionProvider></ProtectedRoute>,
    },


    // ==========================================
    // BOUSANM SOLIDAIRE ADMIN ROUTES
    // ==========================================
    {
        path: "/bousanm-solide/dashboard",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><DashboardBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/clients",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><ClientsBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/agents",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><AgentsBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/transactions",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><TransactionsBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/plans",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><PlansBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/rapports",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><RapportsBS /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/agent/:id",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><AgentDetail /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/agent-portfolio",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><AgentsPortfolio /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/bousanm-solide/assignations",
        element: <ProtectedRoute requiredRoles={FULL_ADMIN_ROLES}><SessionProvider><BousanmSolideProvider><SharedAdminLayout><AssignationsManagement /></SharedAdminLayout></BousanmSolideProvider></SessionProvider></ProtectedRoute>,
    },
    {
        path: "/admin/solide",
        element: <ProtectedRoute requiredRoles={ADMIN_ROLES}><BousanmSolideProvider><DashboardPage /></BousanmSolideProvider></ProtectedRoute>,
    },



    // ==========================================
    // USER PROFILE ROUTES (Any authenticated user)
    // ==========================================
    {
        element: <ProtectedRoute><SessionProvider><Layout /></SessionProvider></ProtectedRoute>,
        children: [
            {
                path: "/home",
                element: <Home />,
            },
            {
                path: "/wallet",
                element: <Wallet />,
            },
            {
                path: "/history",
                element: <History />,
            },
            {
                path: "/profile",
                element: <Profile />,
            },
            {
                path: "/services",
                element: <Services />,
            },
            {
                path: "/services/solide",
                element: <BousanmSolide />,
            },
            {
                path: "/services/ti-kane",
                element: <Construction />,
            },
            {
                path: "/services/sol",
                element: <Construction />,
            },
            {
                path: "/services/placement",
                element: <Construction />,
            },
            {
                path: "/services/pret",
                element: <Construction />,
            },
            {
                path: "/services/payer-sol",
                element: <Construction />,
            },
            {
                path: "/services/credit",
                element: <AcheterCredit />,
            },
            {
                path: "/services/payment/stripe",
                element: <StripePayment />,
            },
            {
                path: "/services/payment/zelle",
                element: <ZellePayment />,
            },
            {
                path: "/services/payment/paypal",
                element: <PayPalPayment />,
            },
            {
                path: "/services/kolabo-connect",
                element: <KolaboConnect />,
            },
            {
                path: "/services/kolabo-tech",
                element: <KolaboTech />,
            },
            {
                path: "/services/kolabo-express",
                element: <KolaboExpress />,
            },
            {
                path: "/services/htla",
                element: <HTLA />,
            },
            {
                path: "/services/imolink",
                element: <Imolink />,
            },
            {
                path: "/services/famamobile",
                element: <Famamobile />,
            },
            {
                path: "/services/biofrit",
                element: <Biofrit />,
            },
            {
                path: "/qrcode",
                element: <QrCodePage />,
            },
            {
                path: "/construction",
                element: <Construction />,
            },
        ],
    },
]);

